"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
exports.__esModule = true;
var specifiler_1 = require("./specifiler");
var util_1 = require("./util");
var subSuffixToValue = {
    '십': 10,
    '백': 100,
    '천': 1000
};
var baseSuffixToValue = {
    '': 1,
    '만': 10000,
    '억': 1e8,
    '조': 1e12,
    '경': 1e16,
    '해': 1e20,
    '자': 1e24,
    '양': 1e28
};
var digitToKorean = {
    '1': '일',
    '2': '이',
    '3': '삼',
    '4': '사',
    '5': '오',
    '6': '육',
    '7': '칠',
    '8': '팔',
    '9': '구'
};
var totalSuffixToValue = __assign({}, baseSuffixToValue, subSuffixToValue);
var Formatter = (function () {
    function Formatter(locale) {
        this.locale = '';
        this.locale = locale;
    }
    Formatter.prototype.convert = function (value) {
        return this.format(value);
    };
    Formatter.prototype.format = function (value) {
        var _a = new specifiler_1["default"](this.locale), align = _a.align, width = _a.width, comma = _a.comma, currency = _a.currency, precision = _a.precision, spacing = _a.spacing, trim = _a.trim, type = _a.type;
        var positive = value >= 0;
        var roundedFormat = this.applyPrecision(value, precision);
        if (!positive) {
            roundedFormat = roundedFormat.substring(1);
        }
        var _b = __read(roundedFormat.split('.'), 2), digits = _b[0], decimal = _b[1];
        decimal = decimal || '';
        var format = '';
        switch (type) {
            case 'b':
                format = this.addSuffix(digits);
                break;
            case 'b+':
                format = this.addSuffix(digits);
                format = this.addSubSuffix(format);
                break;
            case 'k':
                format = this.addSuffix(digits);
                format = this.addSubSuffix(format);
                format = this.convertToKorean(format);
                break;
            default:
                format = this.fixBaseSuffix(digits, decimal, type.substring(1));
                break;
        }
        if (!util_1.isFixType(type)) {
            if (spacing) {
                format = this.applySpacing(format);
            }
            if (trim) {
                decimal = this.trimDecimal(decimal);
            }
            format = format + (decimal ? '.' + decimal : '');
        }
        if (comma) {
            format = this.addComma(format);
        }
        if (currency) {
            format = format + '원';
        }
        if (!positive) {
            format = '-' + format;
        }
        if (width && width > format.length) {
            format = this.alignFormat(format, width, align);
        }
        return format;
    };
    Formatter.prototype.addSuffix = function (digits) {
        var result = '';
        if (digits.length <= 1) {
            return digits;
        }
        var suffixEntries = Object.entries(baseSuffixToValue);
        suffixEntries.forEach(function (pair) {
            var _a = __read(pair, 2), suffix = _a[0], value = _a[1];
            var suffixValueLength = Math.log10(value) + 1;
            if (digits.length >= suffixValueLength) {
                var endIndex = digits.length - suffixValueLength;
                var startIndex = Math.max(0, endIndex - 3);
                var chunk = digits.substring(startIndex, endIndex + 1);
                var notZeroIndex = __spread(chunk).findIndex(function (c) { return c !== '0'; });
                result = (notZeroIndex === -1 ? '' : chunk.substring(notZeroIndex) + suffix) + result;
            }
        });
        return result;
    };
    Formatter.prototype.addSubSuffix = function (format) {
        var suffixes = ['', '십', '백', '천'];
        var startIndex = 0;
        var endIndex = 0;
        var result = '';
        var formatChars = __spread(format).concat(['']);
        formatChars.forEach(function (c, i) {
            if (!util_1.isDigit(c) || i === formatChars.length - 1) {
                var chunk = '';
                endIndex = i - 1;
                for (var j = endIndex; j >= startIndex; j--) {
                    chunk = (formatChars[j] !== '0' ? formatChars[j] + suffixes[endIndex - j] : '') + chunk;
                }
                chunk += c;
                startIndex = i + 1;
                result += chunk;
            }
        });
        return result;
    };
    Formatter.prototype.convertToKorean = function (format) {
        return format.replace('1', '').replace(/([2-9])/g, function (_, g) { return digitToKorean[g]; });
    };
    Formatter.prototype.fixBaseSuffix = function (digits, decimal, base) {
        var baseDigitLength = util_1.getDigitLength(totalSuffixToValue[base]);
        var digitLength = util_1.getDigitLength(+digits);
        if (baseDigitLength > digitLength) {
            var trimmedDecimal = this.trimDecimal('0'.repeat(baseDigitLength - digitLength - 1) + digits + decimal);
            return trimmedDecimal ? '0.' + trimmedDecimal + base : 0 + base;
        }
        else {
            var pointIndex = digitLength - baseDigitLength + 1;
            var trimmedDecimal = this.trimDecimal(digits.substring(pointIndex) + decimal);
            return digits.substring(0, pointIndex) + (trimmedDecimal ? '.' + trimmedDecimal : '') + base;
        }
    };
    Formatter.prototype.applyPrecision = function (value, precision) {
        var digitLength = util_1.rawString(value).replace(/(\.|-)/g, '').length;
        if (!precision) {
            precision = digitLength;
        }
        precision = Math.max(0, Math.min(20, precision));
        if (precision > digitLength) {
            var result = util_1.rawString(value);
            return result
                + (result.includes('.') ? '' : '.')
                + '0'.repeat(precision - digitLength);
        }
        else if (precision === digitLength) {
            return util_1.rawString(value);
        }
        else {
            var precisionValue = Math.pow(10, digitLength - precision);
            return util_1.rawString(Math.round(value / precisionValue) * precisionValue);
        }
    };
    Formatter.prototype.applySpacing = function (format) {
        return format.replace(/([십백천만억조경해자양])(\d+)/g, function (_, g1, g2) { return [g1, g2].join(' '); });
    };
    Formatter.prototype.addComma = function (format) {
        var offset = 0;
        var endIndex = __spread(format).findIndex(function (c) { return c === '.'; }) - 1;
        endIndex = endIndex === -1 ? format.length : endIndex;
        for (var i = format.length; i >= 0; i--) {
            offset = util_1.isDigit(format[i]) ? offset + 1 : 0;
            if (offset === 4) {
                format = format.substring(0, i + 1) + ',' + format.substring(i + 1);
                offset = 1;
            }
        }
        return format;
    };
    Formatter.prototype.trimDecimal = function (decimal) {
        var trimmedLength = __spread(decimal).reverse().findIndex(function (c) { return c !== '0'; });
        if (trimmedLength === -1) {
            return '';
        }
        return decimal.substring(0, decimal.length - trimmedLength);
    };
    Formatter.prototype.alignFormat = function (format, width, align) {
        switch (align) {
            case '>':
                return ' '.repeat(width - format.length) + format;
            case '^':
                var leftMargin = Math.round((width - format.length) / 2);
                var rightMargin = width - format.length - leftMargin;
                return ' '.repeat(leftMargin) + format + ' '.repeat(rightMargin);
            case '<':
                return format + ' '.repeat(width - format.length);
        }
    };
    return Formatter;
}());
function format(locale) {
    var formatter = new Formatter(locale);
    return formatter.format.bind(formatter);
}
exports.format = format;
function convert(locale, value) {
    var formatter = new Formatter(locale);
    return formatter.convert(value);
}
exports.convert = convert;
//# sourceMappingURL=formatter.js.map